<template>
	<md-card-content>
        <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-100">
                <div id="sites-docs-public">
                    <div class="flex items-center justify-between w-full">
                    	<span class="font-bold">
                        	Documents publics
							<span class="font-normal text-xs">(visibles par le client)</span>
						</span>
                        <md-button class="md-info md-icon-button" @mousedown="goToRoute($event,'Add Site Document Public')">
                            <font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
                            <span class="font-medium leading-none ml-2">Ajouter un document public</span>
                        </md-button>
                    </div>
                    <md-list class="md-dense" v-if="publicDocs.length > 0">
                        <md-list-item v-for="document in publicDocs" :key="document.id" class="mb-1">
                            <div class="md-list-item-text flex-row items-center justify-between">
                                <span class="w-auto">{{ document.name }}</span>
                                <div class="w-auto flex items-center">
                                    <div class="mr-1">
                                        <md-button class="md-icon-button md-raised md-info" :href="document.url" target="_blank">
											<font-awesome-icon class="md-icon" :icon="['fa', 'download']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Télécharger</md-tooltip>
                                    </div>
                                    <div>
                                        <md-button class="md-icon-button md-raised md-danger" @click="handleDelete(document)">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'trash']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Supprimer</md-tooltip>
                                    </div>
                                </div>
                            </div>
                        </md-list-item>
                    </md-list>
                    <p v-else>Aucun fichier</p>
                </div>
                <div id="sites-docs-private" class="mt-4">
                    <div class="flex items-center justify-between w-full">
						<span class="font-bold">
							Documents privés
							<span class="font-normal text-xs">(non visibles par le client)</span>
						</span>
                        <md-button class="md-info md-icon-button" @mousedown="goToRoute($event, 'Add Site Document Private')">
							<font-awesome-icon class="md-icon" :icon="['fa', 'plus']" />
							<span class="font-medium leading-none ml-2">Ajouter un document privé</span>
                        </md-button>
                    </div>
                    <md-list class="md-dense" v-if="privateDocs.length > 0">
                        <md-list-item v-for="document in privateDocs" :key="document.id" class="mb-1">
                            <div class="md-list-item-text flex-row items-center justify-between">
                                <span class="w-auto max-w-md">{{ document.name }}</span>
                                <div class="w-auto flex items-center">
                                    <div class="mr-1">
                                        <md-button class="md-icon-button md-raised md-info" :href="document.url" target="_blank">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'download']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Télécharger</md-tooltip>
                                    </div>
                                    <div>
                                        <md-button class="md-icon-button md-raised md-danger" @click="handleDelete(document)">
                                            <font-awesome-icon class="md-icon" :icon="['fa', 'trash']" />
                                        </md-button>
                                        <md-tooltip md-direction="top">Supprimer</md-tooltip>
                                    </div>
                                </div>
                            </div>
                        </md-list-item>
                    </md-list>
                    <p v-else>Aucun fichier</p>
                </div>
            </div>
        </div>
    </md-card-content>
</template>

<script>
// Mixins
import routerMixin from "@/mixins/router-mixin";

export default {
	name: "Documents",
	mixins: [routerMixin],
	props: {
		site: Object
	},
    methods: {
        handleDelete(document) {
            this.$swal.fire({
                title: "Êtes-vous sûr ?",
                text: `Voulez-vous vraiment supprimer ce document : ${document.name} ?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "md-button md-success",
                cancelButtonClass: "md-button md-warning",
                confirmButtonText: "Supprimer",
                cancelButtonText: "Annuler",
                buttonsStyling: false
            }).then(async result => {
                if(result.value) {
                    try {
                        await this.$store.dispatch('site_documents/deleteSiteDocument', document)
                        await this.$store.dispatch("alerts/success", "Document supprimé")
                        this.$emit('deleted')
                    }
                    catch(e) {
                        await this.$store.dispatch("alerts/error", "Suppression impossible")
                    }
                }
            });
        }
    },
	computed: {
		publicDocs() {
			return this.site.documents?.filter(document => { return document.type === 0 }) ?? []
		},
		privateDocs() {
			return this.site.documents?.filter(document => { return document.type === 1 }) ?? []
		},
	},
}
</script>

<style scoped lang="scss">
::v-deep {
    .md-datatable {
        .md-button-content {
            i {
                font-size: 1.1rem !important;
                height: 17px !important;
                width: 15px !important;
                min-width: 15px !important;
            }

            span {
                height: 17px;
                line-height: 18px;
            }
        }
    }

    .md-icon-button {
        margin: 0;
        padding: 5px;
        height: 27px;
        min-width: 35px;
        width: auto;
        line-height: 27px;
        .md-icon {
            font-size: 0.875rem !important;
            min-width: 0.875rem !important;
            height: 0.875rem !important;
        }
    }

    .md-list {
        padding: 0;
        margin-top: 15px;
        .md-list-item {
            margin-left: 0;

            &:last-child {
                margin-bottom: 0;
            }
            .md-list-item-container {
                .md-list-item-content {
                    padding: 0;
                    min-height: 15px;
                    .md-list-item-text {
                        position: relative;
                        * {
                            font-size: .875rem !important;
                        }
                    }
                    .md-button {
                        width: auto;
                        .md-ripple {
                            padding: 0 8px;
                        }
                    }
                    .md-icon {
                        font-size: 0.875rem !important;
                        min-width: 0.875rem !important;
                        height: 0.875rem !important;
                    }
                }
            }
        }
    }
}
</style>
